<template>
  <a-modal
    title="修改打印序号"
    :visible="visible"
    :maskClosable="false"
    ok-text="保存"
    @ok="handleOk"
    @cancel="handleCancel"
  >
    <div>请在下方输入云码序号，序号需要在已生成的云码序号范围内。由于云码已生成，故打印历史云码不扣除云码数量。</div>
    <a-form-model
      :model="form"
      :label-col="labelCol"
      :wrapper-col="wrapperCol"
    >
      <a-form-model-item label="已生成序号">
        {{ range[0] }} - {{ range[1] }}
      </a-form-model-item>
      <a-form-model-item label="打印开始序号">
        <a-input-number v-model="form.start" :min="range[0]" :max="range[1]" />
      </a-form-model-item>
      <a-form-model-item label="打印结束序号">
        <a-input-number v-model="form.end" :min="range[0]" :max="range[1]" />
      </a-form-model-item>
    </a-form-model>
  </a-modal>
</template>

<script>
export default {
  data() {
    return {
      visible: false,
      labelCol: { span: 6 },
      wrapperCol: { span: 14 },
      form: {
        start: '',
        end: ''
      },
      value: 1
    }
  },
  props: {
    range: {
      type: Array,
      default: () => {
        return [1, 1000000]
      }
    },
    start: {
      type: Number,
      default: 0
    },
    end: {
      type: Number,
      default: 0
    }
  },
  methods: {
    showModal() {
      this.visible = true
      this.form = {
        start: this.start,
        end: this.end
      }
    },
    handleOk(e) {
      if (this.form.start > this.form.end) {
        this.$message.error('【打印开始序号】不能大于【打印结束序号】')
        return
      }
      this.$emit('ok', this.form)
      this.visible = false
    },
    handleCancel(e) {
      this.visible = false
    }
  }
}
</script>
